import CareerPlanSuggestion from './CareerPlanSuggestion'
export default CareerPlanSuggestion
